import { render } from "./xtx-tabs-panel.vue?vue&type=template&id=9413e8aa"
import script from "./xtx-tabs-panel.vue?vue&type=script&lang=js"
export * from "./xtx-tabs-panel.vue?vue&type=script&lang=js"

import exportComponent from "F:\\workspan\\java\\lot\\hk-lottery-lhc-pc-ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__